export default __webpack_public_path__ + "static/media/q29_v2.e98fc103.png";